import { render, staticRenderFns } from "./CommonMinusIcon.vue?vue&type=template&id=17e96410"
import script from "./CommonMinusIcon.vue?vue&type=script&lang=js"
export * from "./CommonMinusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports